import React from 'react'
import '../styles/Contact.css'

const Contact = () => {
  return (
    <div className='minHeight100'>
      <div className='hero-section'>
        <h2 className='pagetitle'>CONTACT</h2>
      </div>
      <div className='section-container contact-grid'>
        <img
          className='contact-img'
          src='/contact/superbowl.jpg'
          alt="Super Bowl event"
        />
        <div className='contact-info-grid'>
          <div className='cta-card'>
            <h3>Ready to Partner?</h3>
            <p>
              Join hundreds of brands that have gained world-class exposure through our celebrity gifting experiences.
            </p>
            <p>
              Let's discuss how we can elevate your brand's presence.
            </p>
          </div>
          
          <div className='info-card'>
            <div className='contact-details'>
              <div className='contact-item'>
                <span className='contact-label'>Email</span>
                <a href="mailto:info@giftbagsbyrachael.com" className='contact-value'>
                  info@giftbagsbyrachael.com
                </a>
              </div>
            </div>
            <p className='intro-text contact-note'>
              If you have a product you would like considered for inclusion in an upcoming event, or if you have an upcoming red carpet that is in need of my services, please feel free to get in touch!
            </p>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Contact